import { AlignLeft } from 'lucide-react';
import { z } from 'zod';
import { TextAreaFieldInput, TextAreaFieldView } from '../renderers/fields/textarea/textarea-field';
import type { FieldDefinition, TextAreaFieldSchema } from '../types';

export const TextAreaDefinition: FieldDefinition<TextAreaFieldSchema, string | null | undefined> = {
  type: 'textarea',
  toolboxLabel: 'Long Text',
  category: 'Standard Inputs',
  description: 'A multi-line text area for paragraphs and comments.',
  icon: AlignLeft,

  createDefault: (id) => ({
    id,
    type: 'textarea',
    name: `textarea_${id}`,
    label: 'Long Text Field',
    required: false,
    placeholder: 'Enter long text...',
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
    { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
    {
      id: 'placeholder',
      type: 'text',
      name: 'placeholder',
      label: 'Placeholder Text',
      required: false,
    },
    {
      id: 'required',
      type: 'checkbox',
      name: 'required',
      label: 'Required Field',
      required: false,
    },
    { id: 'minLength', type: 'number', name: 'minLength', label: 'Min Length', required: false },
    { id: 'maxLength', type: 'number', name: 'maxLength', label: 'Max Length', required: false },
  ],

  buildValidation: (field) => {
    let schema = z.string({ error: `${field.label} is required` });

    if (field.minLength !== undefined) {
      schema = schema.min(
        field.minLength,
        `${field.label} must be at least ${field.minLength} characters`
      );
    }

    if (field.maxLength !== undefined) {
      schema = schema.max(
        field.maxLength,
        `${field.label} cannot exceed ${field.maxLength} characters`
      );
    }

    if (field.required) {
      return schema.min(1, `${field.label} is required`);
    }

    return schema.optional().or(z.literal(''));
  },

  editComponent: TextAreaFieldInput,
  viewComponent: TextAreaFieldView,
};
